import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import PageNotFound from 'components/Common/Errors/PageNotFound/PageNotFound';
import Loader from 'components/Common/Loader/Loader';
import useSitePlan from 'hooks/SitePlan/useSitePlan';
import { replaceByLinkEnv } from 'services/formatter';
import { getRoutesUri } from 'services/generic';
import { ENV_HTML_SITEMAP_CATEGORIES_URL } from 'settings/env';

export default function SitePlanCategories(): JSX.Element {
  if (!ENV_HTML_SITEMAP_CATEGORIES_URL) {
    return <PageNotFound />;
  }

  const { t } = useTranslation(['sitePlan']);
  const { content, error, pageNumber } = useSitePlan(
    ENV_HTML_SITEMAP_CATEGORIES_URL
  );

  if ((1 === pageNumber && error) || (error && 404 !== error?.status)) {
    return <PageNotFound />;
  } else if (error && 404 === error?.status) {
    return <Navigate to={getRoutesUri('categorySitemap') as string} />;
  } else if (!content) {
    return <Loader />;
  }

  return (
    <>
      <Helmet>
        <title>{t('META_CATEGORIES_TITLE', { count: pageNumber })}</title>
        <meta name="description" content={t('META_CATEGORIES_DESCRIPTION')} />
      </Helmet>
      <div
        dangerouslySetInnerHTML={{ __html: replaceByLinkEnv(content) }}
      ></div>
    </>
  );
}
